import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import logo from "../img/werkenbijsmith-logo.svg";

function Footer() {
    return (
        <footer className="site-footer">
            <div className="site-container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <Link to="/">
                            <img
                                src={logo}
                                alt="Werken bij Smith"
                                width="245"
                                height="71"
                            />
                        </Link>
                        <p>
                            Jouw talent. Onze energie.
                            <br />
                            Samen bouwen we aan morgen.
                        </p>
                        <span className="footer-location">
                            <Icon name="pin" /> Maasdijk, het Westland
                        </span>
                    </div>
                    <div>
                        <h2>Jouw toekomst</h2>
                        <Link to="/#vacatures">Bekijk de vacatures</Link>
                        <Link to="/#over-smith">Werken bij Smith</Link>
                        <Link to="/#kennismaken">Even kennismaken</Link>
                        <Link to="/open-sollicitatie">
                            Open sollicitatie <Icon />
                        </Link>
                    </div>
                    <div>
                        <h2>De Smith-familie</h2>
                        <a
                            href="https://smithsolar.nl/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Smith Solar <Icon name="diagonal" />
                        </a>
                        <a
                            href="https://smithtuinbouwtechniek.nl/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Smith Tuinbouwtechniek <Icon name="diagonal" />
                        </a>
                        <a
                            href="https://gridsense.nl/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GridSense <Icon name="diagonal" />
                        </a>
                    </div>
                    <div>
                        <h2>We horen graag van je</h2>
                        <p>
                            Een vraag over werken bij Smith?
                            <br />
                            Stuur ons gerust een bericht.
                        </p>
                        <a
                            className="footer-email"
                            href="mailto:hr@smithtechniek.nl"
                        >
                            hr@smithtechniek.nl <Icon name="diagonal" />
                        </a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <span>
                        © 2009 – {new Date().getFullYear()} J.K. Smith Holding
                        B.V.
                    </span>
                    <span>
                        Een website van{" "}
                        <a
                            href="https://srproductions.nl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            SR Productions
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
}
export default React.memo(Footer);
